exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--bck:linear-gradient(0deg,#ea5020,#d13808);--xz:#d13808;--xt:#e5332d;--biao:#f1683a;--zhuan:#3f86bc;--btn:linear-gradient(0deg,#e5332d,#fb443e);--bei:#fff6f3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/skin.css
// module id = 584
// module chunks = 0